// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperSelector-cls1__hy","cls2":"PaperSelector-cls2_xLU PaperSelector-cls1__hy"};